import hometrackUpgradeCTAHeroImageSrc from "public/addons/hometrack/upgrade-promo-card-hero.jpg";
import { UpgradeCTA } from "react-migration/components/UpgradeCTA";
import { HometrackUpgradeButton } from "./HometrackUpgradeButton";

const hometrackListItems = [
  "Latest valuations (inc. indexed current valuations)",
  "Asking prices from on-market listings",
  "Asking rents and values from on-market listings",
  "Biggest portfolio of UK property information",
  "Links to on-market listings on Zoopla",
];

export function HometrackUpgradeCTA() {
  return (
    <UpgradeCTA
      imageSrc={hometrackUpgradeCTAHeroImageSrc}
      imageAlt="Hometrack - Understand the market ahead of the competition"
      title="Hometrack"
      description="Unparalleled and accurate property market intelligence from the experts - Zoopla and Hometrack"
      listItems={hometrackListItems}
      ctaElement={<HometrackUpgradeButton logClickSource="explore-promotion-card" />}
    />
  );
}
